<template>
  <section class="catalog-grid no-gutters c-sm:c-justify-center c-md:c-justify-start c-flex-col c-mt-2 c-md:c-mt-3 c-lg:c-mt-4 catalog__grid">
    <template v-if="isLoaded">
      <template
        v-for="(product, index) in products"
        :key="product.id"
      >
        <ProductItem
          class="catalog-grid-item"
          :product_index="index"
          :product="product"
          :status="cardStatus"
          :lazy-load="index > 2"
          :info-click-behaviour="infoClickBehaviour"
          :is-search-page="isSearchPage"
        />
        <div
          v-if="index === 1 && isTodayInRange(deliveryLinks[country].dateStart, deliveryLinks[country].dateEnd) && country !== 'it'"
          class="flex-1 bg-white rounded-lg overflow-hidden"
        >
          <a
            :href="deliveryLinks[country].link"
            rel="noopener"
          >
            <ResponsiveImage
              img-class="w-100 h-100 block"
              :src="`banner-delivery-${country !== 'at' ? locale : 'de'}.jpg`"
            />
          </a>
        </div>
        <div
          v-if="index === 1 && !isTodayInRange(deliveryLinks[country].dateStart, deliveryLinks[country].dateEnd) && country !== 'it'"
          class="flex-1 bg-white rounded-lg overflow-hidden"
        >
          <a
            :href="tempEaster[country !== 'at' ? locale : 'de']"
            rel="noopener"
          >
            <ResponsiveImage
              img-class="w-100 h-100 block"
              :src="`banner-easter-${country !== 'at' ? locale : 'de'}.jpg`"
            />
          </a>
        </div>
        <template v-if="index === 4 && isTodayInRange(deliveryLinks[country].dateStart, deliveryLinks[country].dateEnd) && country !== 'it'">
          <div
            v-if="country === 'fr'"
            class="flex-1 bg-white rounded-lg overflow-hidden"
          >
            <a
              :href="tempEaster[country !== 'at' ? locale : 'de']"
              rel="noopener"
            >
              <ResponsiveImage
                img-class="w-100 h-100 block"
                :src="`banner-easter-${country !== 'at' ? locale : 'de'}.jpg`"
              />
            </a>
          </div>
          <div
            v-else
            class="flex-1 bg-white rounded-lg overflow-hidden"
          >
            <RouterLink
              v-if="randomBool()"
              :to="{ name: 'productPath', params: { permalink: tempBanners[1].permalink[country !== 'at' ? locale : 'de'] } }"
            >
              <ResponsiveImage
                img-class="w-100 h-100 block"
                :src="`${tempBanners[1].image}_${country !== 'at' ? locale : 'de'}.jpg`"
              />
            </RouterLink>
            <a
              v-else
              :href="tempEaster[country !== 'at' ? locale : 'de']"
              rel="noopener"
            >
              <ResponsiveImage
                img-class="w-100 h-100 block"
                :src="`banner-easter-${country !== 'at' ? locale : 'de'}.jpg`"
              />
            </a>
          </div>
        </template>
        <div
          v-else-if="index === 4 && country !== 'fr' && country !== 'it'"
          class="flex-1 bg-white rounded-lg overflow-hidden"
        >
          <RouterLink
            :to="{ name: 'productPath', params: { permalink: tempBanners[1].permalink[country !== 'at' ? locale : 'de'] } }"
          >
            <ResponsiveImage
              img-class="w-100 h-100 block"
              :src="`${tempBanners[1].image}_${country !== 'at' ? locale : 'de'}.jpg`"
            />
          </RouterLink>
        </div>
      </template>
    </template>
    <template v-else>
      <article
        v-for="index in 3"
        :key="index"
        class="catalog-grid-item product-item relative flex c-flex-col c-flex-grow-1 c-p-4 c-sm:c-p-3 c-md:c-p-4 w-100"
      >
        <div class="c-mb-4">
          <PlaceholderLoader
            class="block c-rounded"
            style="padding-bottom: 75%;"
          />
        </div>
        <PlaceholderLoader
          class="c-mb-2 c-rounded"
          style="height: 24px; width: 130px;"
        />
        <PlaceholderLoader
          class="c-mb-2 c-rounded"
          style="height: 22px; width: 70%;"
        />
        <PlaceholderLoader
          class="c-rounded"
          style="height: 63px; width: 70%;"
        />
        <div class="c-pt-3 c-xl:c-pt-4 c-pb-2">
          <PlaceholderLoader
            class="c-rounded"
            style="height: 35px;"
          />
        </div>
        <PlaceholderLoader
          class="form-row c-mt-auto c-rounded c-mx-0"
          style="height: 66px;"
        />
      </article>
    </template>
  </section>
</template>

<script setup>
import PlaceholderLoader from '@/components/general/BasePlaceholderLoader.vue'
import ProductItem from '@/components/products/ProductsCatalogGridItem.vue'
import { useCountry } from '@/mixins/useCountry'
import ResponsiveImage from '@/components/general/BaseImage.vue'
import { useI18n } from 'vue-i18n'

const { locale } = useI18n()
const country = useCountry()

const shuffleArray = (array) => {
  for (var i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
}

const randomBool = () => {
  return Math.random() < 0.5;
}

const tempEaster = {
  cs: 'https://mix.it/vajicka-banner',
  de: 'https://mix.it/eier-banner',
  hu: 'https://mix.it/tojasok-banner',
  pl: 'https://mix.it/jajeczka-banner',
  ro: 'https://mix.it/oua-banner',
  sk: 'https://mix.it/vajicka-banner-sk',
  at: 'https://mix.it/eier-banner-at',
  fr: 'https://mix.it/oeufs-banner'
};

const tempBanners = [
  {
    image: 'banner_crunchy',
    permalink: {
      cs: 'crunchy-corn-peri-peri-and-kajensky-pepr-do-kapsy-2730',
      de: 'crunchy-corn-piri-piri-and-cayennepfeffer-im-taschenformat-2730',
      hu: 'zsebbe-valo-crunchy-corn-piri-piri-and-cayenne-2730',
      pl: 'crunchy-corn-do-kieszeni-peri-peri-z-pieprzem-kajenskim-2730',
      ro: 'crunchy-corn-piri-piri-and-piper-cayenne-pungu-a-2730',
      sk: 'crunchy-corn-piri-piri-and-kajenske-korenie-do-vrecka-2730'
    },
      
  },
  {
    image: 'banner_cheddar',
    permalink: {
      cs: 'degustacni-sada-krupavych-syru-do-kapsy-3231',
      de: 'probierset-knusprige-kase-im-taschenformat-3231',
      hu: 'kostolo-sajtos-csomag-3231',
      pl: 'zestaw-degustacyjny-chrupiacych-serow-do-kieszeni-3231',
      ro: 'set-de-branza-crocanta-la-punguta-3231',
      sk: 'degustacna-sada-chrumkavych-syrov-do-vrecka-3231'
    },
  },
];
shuffleArray(tempBanners);

function isTodayInRange(startDate, endDate) {
  const today = new Date();

  // Normalize times to ignore hours/minutes/seconds
  today.setHours(0, 0, 0, 0);

  const start = new Date(startDate);
  const end = new Date(endDate);

  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);

  return today >= start && today <= end;
}

const deliveryLinks = {
  cs: {
    link: 'https://mix.it/doprava-banner',
    dateStart: '2026-02-20',
    dateEnd: '2026-03-02'
  },
  sk: {
    link: 'https://mix.it/doprava-banner-sk',
    dateStart: '2026-02-20',
    dateEnd: '2026-03-02'
  },
  pl: {
    link: 'https://mix.it/dostawa-banner',
    dateStart: '2026-02-27',
    dateEnd: '2026-03-09'
  },
  hu: {
    link: 'https://mix.it/szallitas-banner',
    dateStart: '2026-02-27',
    dateEnd: '2026-03-09'
  },
  ro: {
    link: 'https://mix.it/livrare-banner',
    dateStart: '2026-02-27',
    dateEnd: '2026-03-09'
  },
  de: {
    link: 'https://mix.it/lieferung-banner-de',
    dateStart: '2026-02-27',
    dateEnd: '2026-03-09'
  },
  at: {
    link: 'https://mix.it/lieferung-banner-at',
    dateStart: '2026-02-27',
    dateEnd: '2026-03-09'
  },
  fr: {
    link: 'https://mix.it/livraison-banner',
    dateStart: '2026-02-27',
    dateEnd: '2026-03-09'
  },
  it: {
    link: '',
    dateStart: '2026-01-01',
    dateEnd: '2026-01-02'
  }
};

defineProps({
  products: {
    type: Array,
    required: true,
  },

  infoClickBehaviour: {
    type: String,
    default: 'modal',
  },

  isLoaded: {
    type: Boolean,
    required: true,
  },

  cardStatus: {
    type: String,
    default: 'default'
  },

  isSearchPage: {
    type: Boolean,
    default: false,
  }
})
</script>